import React from 'react';

import './_shop-all-solids-item.scss';
import {ApiHostsEnum} from '../../../entities/pageSetup/apiHosts';
import useApiHost from '../../../entities/pageSetup/apiHosts/useApiHost';
import {translate} from '../../../services';
import {Locale} from '../../../shapes/locale';
import LazyImage from '../LazyImage/LazyImage';
import LinkWrapper from '../LinkWrapper/LinkWrapper';


export interface ShopAllSolidsItemProps {
  locale: Locale;
}

const ShopAllSolidsItem = ({locale}: ShopAllSolidsItemProps): JSX.Element => {
  const imagesHost = useApiHost(ApiHostsEnum.images);
  const imageSource = `${imagesHost}/icons/color-wheel.png`;

  const title = translate('designs.coordinatingSolidsShopAll');

  return (
    <div className='b-design-item x-condensed'>
      <LinkWrapper
        className='design-link'
        hrefValue={`/${locale}/solid-fabric/petal-signature-cotton`}
        title={title}
        contents={
          <div className='b-shop-all-solids-item'>
            <LazyImage
              src={imageSource}
              alt={translate('designs.coordinatingSolidsShopAllImageAlt')}
              height={21}
              width={21}
            />
            <p className='b-shop-all-solids-item-title'>{title}</p>
          </div>
        }
      />
    </div>
  );
};

export default ShopAllSolidsItem;
